<template>
  <section
    :classes="['customizer-ugc3-overlay', 'ugc-confirm-design']"
  >
    <div>
      <div :class="['ugc-confirm-design-main-image text-center', { 'tmall': tmallEnabled }]">
        <base-spinner></base-spinner>
        <img
          v-if="!isLoading"
          :src="imagesPreview[compositeImgKey].imgSrc"
          :alt="pdm.product_name"
        />
      </div>
      <div v-if="tmallEnabled" class="ugc-confirm-design-tmall-message text-center">
        *{{ translations.ugcTmallDesignReadyMessage }}
      </div>
      <div class="ugc-confirm-design-thumbnail-image">
        <ul
          class="ugc-confirm-design-thumbnail-image-menu text-center"
          v-if="!isLoading"
        >
          <li
            v-for="(item, key) in imagesPreview"
            v-bind:key="key"
            :class="[{ active: item.active }]"
            @click="setActive(key)"
          >
            <img :src="item.imgSrc" :alt="pdm.product_name" @load="loading" />
          </li>
        </ul>
      </div>
      <div class="ugc-confirm-design-main-text text-center">
        {{ translations.ugcConfirmDesc }}
      </div>
    </div>
  </section>
</template>

<script>
import baseSpinner from '@/components/Spinner';
import canvasUtils from "@/plugins/canvas/CanvasUtils";
import { getRegion, getLocale, getCaid, getConfigurationObject } from "@/data/regionInfo";

export default {
  name: "UgcConfirmDesign",
  components: {
    baseSpinner
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    productImages() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].productImages;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    componentName() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCComponent;
    },
    tmallEnabled() {
      return this.$store.getters['utils/tmallEnabled'];
    },
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    },
  },
  data() {
    return {
      isLoading: true,
      compositeImgKey: null,
      imagesPreview: {},
      viewDisplayNames: []
    };
  },
  methods: {
    setActive(key) {
      this.imagesPreview[key].active = true;
      this.imagesPreview[this.compositeImgKey].active = false;
      this.compositeImgKey = key;
      this.$eventBus.$emit(
        "show-view-displayName",
        this.viewDisplayNames.length > 0 ? this.viewDisplayNames[index] : ""
      );
    },
    loading() {
      this.$eventBus.$emit("hide-customs-spinner", true);
      this.$eventBus.$emit("disable-finish-button");
    },
    showSpinner() {
      this.$eventBus.$emit("hide-customs-spinner", false);
    },

    createCompositeImages() {
      this.imagesPreview = {};
      let featuredView = this.pdm.product_images.featured_views
        .ugc_confirm_design_images;

      let compositeImages = {};
      for (let i = 0; i < featuredView.length; i++) {
        let composite = [];
        if (featuredView[i].size.includes("lg-")) {
          composite.push(featuredView[i]);
          if (featuredView[i].view.includes("comp")) {
            i = i + 1;
            composite.push(featuredView[i]);
          }
          const compositeKey = `composite_${i}`;
          compositeImages[compositeKey] = composite;

          this.imagesPreview[compositeKey] = {
            active: false,
            caption: compositeKey,
            imgSrc: ''
          };

          if (!this.compositeImgKey) {
            this.compositeImgKey = compositeKey;
            this.imagesPreview[compositeKey].active = true;
          }
        }
      }
      return compositeImages;
    },

    processImages(data) {
      let composite_images = this.createCompositeImages();

      const width = this.pdm.product_images.renditions.square.width;
      const height = this.pdm.product_images.renditions.square.height;
      const compositeKeys = Object.keys(composite_images);

      Promise.all(
        compositeKeys.map(key => {
          const backView = composite_images[key][0];
          const images = [
            canvasUtils.getImageFromUrl(
              data[`${backView.view}_view`][backView.size]
            )
          ];
          if (composite_images[key].length > 1) {
            const frontView = composite_images[key][1];
            images.push(
              canvasUtils.getImageFromUrl(
                data[`${frontView.view}_view`][frontView.size]
              )
            );
          }
          return Promise.all(images)
            .then(([imageBuffer, imageOverlay]) => {
              return canvasUtils.applyImageOverlay({
                imageBuffer,
                imageOverlay,
                width: width,
                height: height
              });
            })
            .then(imageBase64 => {
              this.imagesPreview[key]['imgSrc'] = imageBase64.src;
            });
        })
      ).then(() => {
        this.isLoading = false;
        this.$nextTick(()=>{
          document.querySelector("#close-button-newUgcModal svg").focus();
        })
      });
    },
    getUgcConfirmDesignImages() {
      const recipe = this.$store.getters["ugc/tempData/getRecipe"];
      const images = this.pdm.product_images.featured_views.ugc_confirm_design_images;

      this.$store
        .dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE", { recipe, images, locale: getLocale(), })
        .then(data => {
          this.processImages(data);

          const dataLayerData = {
            ugcStep: 'confirmDesignLoaded',
            timeStamp: new Date().toISOString(),
            event: "ugcStep",
            eventCategory:'customs',
            eventAction:'UGC',
            eventLabel: 'confirmDesignLoaded',
          };
          const dataLayerSource = this.canvasActive ? parent.dataLayer : dataLayer;
          dataLayerSource.push(dataLayerData);
        })
        .catch(err => {
          console.error("Error getting product images by recipe:", err);
        });
    }
  },
  created() {
    this.$eventBus.$emit("show-finish-button", true);
    this.$eventBus.$emit("hide-customs-spinner", false);

    this.$eventBus.$on("show-spinner-finish", this.showSpinner);

    this.getUgcConfirmDesignImages();
  },
  beforeDestroy() {
    this.$eventBus.$emit("show-finish-button", false);
    this.$eventBus.$off("show-spinner-finish");
  }
};
</script>
